const promoParam = 'promo=1';
const customIconParam = 'customIcon=1';

export { customIconParam, promoParam };
//# sourceMappingURL=links.js.map
